import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {UrlService} from './url.service';

@Injectable()
export class PdfPrintService {
    private BASE_URL: string;

    constructor(private http: HttpClient,
                private urlService: UrlService) {
        this.BASE_URL = this.urlService.getBackendUrl() + 'data/pdf';
    }

    public printAssessmentPdf(assessmentId, assessmentGroupId,
                              clientIdentifier, assessmentDate, includeAlgos, actionableOnly, summaryOnly,
                              languageCode?) {
        let params = new HttpParams();
        if (assessmentId) {
            params = params.set('assessmentId', assessmentId);
        }
        if (assessmentGroupId) {
            params = params.set('assessmentGroupId', assessmentGroupId);
        }
        if (clientIdentifier) {
            params = params.set('clientIdentifier', clientIdentifier);
        }
        if (assessmentDate) {
            params = params.set('assessmentDate', assessmentDate);
        }
        if (includeAlgos !== undefined && includeAlgos !== null) {
            params = params.set('includeAlgos', includeAlgos);
        }
        if (actionableOnly !== undefined && actionableOnly !== null) {
            params = params.set('actionableOnly', actionableOnly);
        }
        if (summaryOnly !== undefined && summaryOnly !== null) {
            params = params.set('summaryOnly', summaryOnly);
        }
        if (languageCode) {
            params = params.set('languageCode', languageCode);
        }

        const requestOptions: Object = {
            responseType: 'blob',
            params: params
        }

        return this.http.get(this.BASE_URL + '/assessmentPrint', requestOptions);
    }

    public printAssessmentComparisonPdf(assessmentIds
        , assessmentGroupIds
        , clientIdentifier
        , includeAlgos
    ) {

        let params = new HttpParams();
        if (assessmentIds) {
            params = params.set('assessmentIds', assessmentIds);
        }
        if (assessmentGroupIds) {
            params = params.set('assessmentGroupIds', assessmentGroupIds);
        }
        if (clientIdentifier) {
            params = params.set('clientIdentifier', clientIdentifier);
        }

        if (includeAlgos !== undefined && includeAlgos !== null) {
            params = params.set('includeAlgos', includeAlgos);
        }

        const requestOptions: Object = {
            responseType: 'blob',
            params: params
        }

        return this.http.get(this.BASE_URL + '/assessmentComparisonPrint', requestOptions);
    }

    public printM3AssessmentPdf(assessmentId, assessmentGroupId, clientIdentifier, assessmentDate, includeAlgos,
                               languageCode?) {
        let params = new HttpParams();
        if (assessmentId) {
            params = params.set('assessmentId', assessmentId);
        }
        if (assessmentGroupId) {
            params = params.set('assessmentGroupId', assessmentGroupId);
        }
        if (clientIdentifier) {
            params = params.set('clientIdentifier', clientIdentifier);
        }
        if (assessmentDate) {
            params = params.set('assessmentDate', assessmentDate);
        }
        if (includeAlgos !== undefined && includeAlgos !== null) {
            params = params.set('includeAlgos', includeAlgos);
        }
        if (languageCode) {
            params = params.set('languageCode', languageCode);
        }

        const requestOptions: Object = {
            responseType: 'blob',
            params: params
        }

        return this.http.get(this.BASE_URL + '/assessmentM3Print', requestOptions);
    }

    public printAssessmentEdePdf(assessmentId, clientIdentifier, assessmentDate, languageCode?) {
        let params = new HttpParams();
        if (assessmentId) {
            params = params.set('assessmentId', assessmentId);
        }
        if (clientIdentifier) {
            params = params.set('clientIdentifier', clientIdentifier);
        }
        if (assessmentDate) {
            params = params.set('assessmentDate', assessmentDate);
        }
        if (languageCode) {
            params = params.set('languageCode', languageCode);
        }

        const requestOptions: Object = {
            responseType: 'blob',
            params: params
        }

        return this.http.get(this.BASE_URL + '/assessmentEdePrint', requestOptions);
    }

    public printAssessmentEdeqaPdf(assessmentId, clientIdentifier, assessmentDate, languageCode?) {
        let params = new HttpParams();
        if (assessmentId) {
            params = params.set('assessmentId', assessmentId);
        }
        if (clientIdentifier) {
            params = params.set('clientIdentifier', clientIdentifier);
        }
        if (assessmentDate) {
            params = params.set('assessmentDate', assessmentDate);
        }
        if (languageCode) {
            params = params.set('languageCode', languageCode);
        }

        const requestOptions: Object = {
            responseType: 'blob',
            params: params
        }

        return this.http.get(this.BASE_URL + '/assessmentEdeqaPrint', requestOptions);
    }

    public printOldPhantomPdf(documentSourceId, properties) {
        const requestOptions: Object = {
            responseType: 'blob'
        };

        return this.http.post(this.BASE_URL + '/' + documentSourceId, properties, requestOptions);
    }

    notifyReadyForPrint() {
        if (window['htmlPdfPrintReady']) {
            // Wait for Angular to render DOM
            setTimeout(() => {
                window['htmlPdfPrintReady']();
            }, 500);
        }
    }

    printImpactDetailPdf(impactParameters: any): Observable<any> {
        let params = new HttpParams();

        // Add all impact parameters to the request
        if (impactParameters.instrumentIds) {
            params = params.set('instrumentIds', impactParameters.instrumentIds);
        }
        if (impactParameters.fromDate2) {
            params = params.set('fromDate2', impactParameters.fromDate2);
        }
        if (impactParameters.toDate2) {
            params = params.set('toDate2', impactParameters.toDate2);
        }
        if (impactParameters.fromDate1) {
            params = params.set('fromDate1', impactParameters.fromDate1);
        }
        if (impactParameters.toDate1) {
            params = params.set('toDate1', impactParameters.toDate1);
        }
        if (impactParameters.questionIds) {
            params = params.set('questionIds', impactParameters.questionIds);
        }
        if (impactParameters.ouIds) {
            params = params.set('ouIds', impactParameters.ouIds);
        }
        if (impactParameters.ouTagIds) {
            params = params.set('ouTagIds', impactParameters.ouTagIds);
        }
        if (impactParameters.ouListFromOuTags !== undefined) {
            params = params.set('ouListFromOuTags', impactParameters.ouListFromOuTags.toString());
        }
        if (impactParameters.aggregateOus !== undefined) {
            params = params.set('aggregateOus', impactParameters.aggregateOus.toString());
        }
        if (impactParameters.aggregateUsers !== undefined) {
            params = params.set('aggregateUsers', impactParameters.aggregateUsers.toString());
        }
        if (impactParameters.toTypes) {
            params = params.set('toTypes', impactParameters.toTypes);
        }
        if (impactParameters.fromTypes) {
            params = params.set('fromTypes', impactParameters.fromTypes);
        }
        if (impactParameters.assessmentStatuses) {
            params = params.set('assessmentStatuses', impactParameters.assessmentStatuses);
        }
        if (impactParameters.placementStatus !== undefined) {
            params = params.set('placementStatus', impactParameters.placementStatus.toString());
        }
        if (impactParameters.minDuration) {
            params = params.set('minDuration', impactParameters.minDuration);
        }
        if (impactParameters.assessmentDistance) {
            params = params.set('assessmentDistance', impactParameters.assessmentDistance);
        }
        if (impactParameters.ageRange) {
            params = params.set('ageRange', impactParameters.ageRange);
        }
        if (impactParameters.detailType) {
            params = params.set('detailType', impactParameters.detailType);
        }
        if (impactParameters.respUserIds) {
            params = params.set('respUserIds', impactParameters.respUserIds);
        }

        const requestOptions: Object = {
            responseType: 'blob',
            params: params
        };

        return this.http.get(this.BASE_URL + '/impactDetailPrint', requestOptions);
    }

    printTicklerEpisodePdf(ticklerEpisodeParameters: any): Observable<any> {
        let params = new HttpParams();

        if (ticklerEpisodeParameters.instrumentIds) {
            params = params.set('instrumentIds', ticklerEpisodeParameters.instrumentIds);
        }
        if (ticklerEpisodeParameters.fromDate) {
            params = params.set('fromDate', ticklerEpisodeParameters.fromDate);
        }
        if (ticklerEpisodeParameters.toDate) {
            params = params.set('toDate', ticklerEpisodeParameters.toDate);
        }
        if (ticklerEpisodeParameters.ouIds) {
            params = params.set('ouIds', ticklerEpisodeParameters.ouIds);
        }
        if (ticklerEpisodeParameters.assessorIds) {
            params = params.set('assessorIds', ticklerEpisodeParameters.assessorIds);
        }
        if (ticklerEpisodeParameters.hideComplete !== undefined) {
            params = params.set('hideComplete', ticklerEpisodeParameters.hideComplete.toString());
        }
        if (ticklerEpisodeParameters.protocol) {
            params = params.set('protocol', ticklerEpisodeParameters.protocol);
        }
        if (ticklerEpisodeParameters.inventoryOnly !== undefined) {
            params = params.set('inventoryOnly', ticklerEpisodeParameters.inventoryOnly.toString());
        }

        const requestOptions: Object = {
            responseType: 'blob',
            params: params
        };

        return this.http.get(this.BASE_URL + '/ticklerEpisodePrint', requestOptions);
    }

    getKentuckyComparisonReport(assessmentGroupId, clientIdentifier) {
        let params = new HttpParams();

        if (assessmentGroupId) {
            params = params.set('assessmentGroupId', assessmentGroupId);
        }
        if (clientIdentifier) {
            params = params.set('clientIdentifier', clientIdentifier);
        }


        const requestOptions: Object = {
            responseType: 'blob',
            params: params
        };

        return this.http.get(this.BASE_URL + '/kentuckyComparisonReport', requestOptions);
    }
}
